export default {
  title: {
    id: 'bo_sellers-opportunities-title',
    defaultMessage: 'Opportunities',
  },
  tabsBarLabel: {
    id: 'bo_sellers-opportunities-tabs_bar',
    defaultMessage: 'Opportunities tabs',
  },
  pricingTab: {
    id: 'bo_sellers-opportunities-pricing_tab',
    defaultMessage: 'Pricing',
  },
  inventoryTab: {
    id: 'bo_sellers.opportunities.inventory_tab',
    defaultMessage: 'Inventory',
  },
  dealsTab: {
    id: 'bo_seller.opportunities.tabs.deals',
    defaultMessage: 'Deals',
  },
}
